import React, { useEffect, useRef, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import { useAuth } from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const EditTestimonial = () => {
    const { id } = useParams()
    const [testimonial, setTestimonial] = useState(null)
    const { logout, user } = useAuth();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [studentName, setStudentName] = useState('')
    const [className, setClassName] = useState('')
    const [imgFile, setImgFile] = useState(null)
    const [comment, setComment] = useState('')
    const [rating, setRating] = useState('')
    const [ytlink, setYtlink] = useState('')
    const [active, setActive] = useState(true)
    const [previewImgUrl, setPreviewImgUrl] = useState(null);
    const [processing, setProcessing] = useState(false)
    const [loading, setLoading] = useState(false)

    const imgFileRef = useRef()
    const data = { studentName, className, comment, rating, ytlink, active }

    const getTestimonial = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${baseUrl}/testimonial/${id}`);
            const { studentName, ytlink, rating, comment, show, className } = response.data
            setClassName(className)
            setTestimonial(response.data);
            setStudentName(studentName)
            setComment(comment)
            setActive(show ? show : false)
            setYtlink(ytlink)
            setRating(rating)
        } catch (error) {
            console.error('Error fetching blog:', error?.response?.data?.message || error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) getTestimonial();
    }, [id])

    const handleSubmit = (e) => {
        e.preventDefault();

        let isValid = true;

        if (studentName.trim() === '') {
            toast.error("Please enter the student's name");
            isValid = false;
        }

        if (className.trim() === '') {
            toast.error("Please enter the class name");
            isValid = false;
        }

        if (comment.trim() === '') {
            toast.error("Please enter the testimonial/comment");
            isValid = false;
        }

        if (!rating || isNaN(rating)) {
            toast.error("Please provide a valid rating");
            isValid = false;
        } else if (rating < 1 || rating > 5) {
            toast.error("Rating must be between 1 and 5");
            isValid = false;
        }

        if (!isValid) return;

        const formData = new FormData();
        formData.append('imgFile', imgFile && imgFile[0]);
        formData.append('data', JSON.stringify(data));
        setProcessing(true)

        axios
            .post(`${baseUrl}/testimonial/edit/${id}`, formData)
            .then((res) => {
                toast.success(res.data.message);
                setProcessing(false)
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || 'Something went wrong');
                console.error(err);
                setProcessing(false)
            });
    };


    const handleImgFile = (e) => {
        const file = e.target.files[0];
        const validFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const maxSizeInBytes = 2 * 1024 * 1024;
        if (file && validFileTypes.includes(file.type) &&
            file.size <= maxSizeInBytes) {
            setImgFile([file])
            setPreviewImgUrl(URL.createObjectURL(file));
            toast.success('Image loaded')
        }
        else {
            toast.error('Invalid file. Only Image files (jpeg,jpg,png) under 2MB are allowed.')
            setImgFile(null);
            setPreviewImgUrl(null);
            imgFileRef.current.value = ""
        }

    }

    useEffect(() => {
        return () => {
            if (previewImgUrl) {
                URL.revokeObjectURL(previewImgUrl);
            }
        };
    }, [previewImgUrl]);

    return (
        <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
            <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
                <SideBar />
            </aside>

            <main className={styles.mainContent}>
                <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
                <nav aria-label="breadcrumb" >
                    <ol className="breadcrumb">
                        <div className="d-flex flex-grow-1">
                            <li className="breadcrumb-item">
                                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to='/admin/testimonials' className="text-decoration-none">Testimonials</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                Edit Testimonial
                            </li>
                        </div>
                        <li className="nav-item dropdown">
                            <span
                                className="nav-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                                href=""
                                role="button"
                                aria-expanded="false"
                            >
                                Welcome, {user.name}
                                <i className="ml-2 fa fa-angle-down"></i>
                            </span>
                            <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                                <li>
                                    <span className="dropdown-item" onClick={logout}>
                                        Logout
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </nav>
                <div
                    className={`container ${styles.container}`}>
                    <div className="bg-white p-4">
                        <h4>Edit Testimonial</h4>
                        <div className="row mb-3">
                            <div className="col-lg-6">
                                <label htmlFor="studentName" className="form-label">
                                    Student Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="studentName"
                                    placeholder="Enter Student Name"
                                    onChange={(e) => setStudentName(e.target.value)}
                                    value={studentName}
                                />
                            </div>
                            <div className="col-lg-6">
                                <label htmlFor="class" className="form-label">
                                    Select Class
                                </label>
                                <select
                                    onChange={(e) => setClassName(e.target.value)}
                                    className="form-select"
                                    id="class"
                                    aria-label="Select Class Name"
                                    value={className}
                                >
                                    <option value=''>Select class</option>
                                    <option>Class XI</option>
                                    <option>Class XII</option>
                                    <option>Class XII Passed</option>
                                </select>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-lg-6">
                                {testimonial?.studentImage && (
                                    <div className="mb-2">
                                        <label className="form-label d-block">Image Preview:</label>
                                        <img
                                            src={
                                                previewImgUrl
                                                    ? previewImgUrl
                                                    : testimonial?.studentImage
                                                        ? `${process.env.REACT_APP_API_URL}${testimonial?.studentImage}`
                                                        : ""
                                            }
                                            alt="Image Preview"
                                            style={{ maxWidth: "100%", height: "auto", maxHeight: "200px" }}
                                        />
                                    </div>
                                )}
                                <label htmlFor="imgFile" className="form-label">
                                    Student Image
                                </label>
                                <input
                                    id="imgFile"
                                    ref={imgFileRef}
                                    onChange={handleImgFile}
                                    type="file"
                                    className="form-control"
                                />
                            </div>
                            <div className="col-lg-6">
                                <label htmlFor="rating" className="form-label">
                                    Rating (1-5)
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="rating"
                                    placeholder="Enter rating between 1 & 5"
                                    onChange={(e) => setRating(e.target.value)}
                                    value={rating}
                                />
                            </div>
                        </div>
                        <div className="row mb-3 mt-3">
                            <div className="col-12">
                                <label htmlFor="comment" className="form-label">
                                    Comment
                                </label>
                                <textarea
                                    onChange={(e) => setComment(e.target.value)}
                                    value={comment}
                                    className="form-control"
                                ></textarea>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-lg-6">
                                <label htmlFor="ytlink" className="form-label">
                                    Youtube Link
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="ytlink"
                                    placeholder="Enter youtube link"
                                    onChange={(e) => setYtlink(e.target.value)}
                                    value={ytlink}
                                />
                            </div>

                            <div className="col-lg-6">
                                <label htmlFor="status" className="form-label">
                                    Status :                   {
                                        active ?
                                            <label htmlFor="active" className="form-label">
                                                Active
                                            </label> :
                                            <label htmlFor="inactive" className="form-label">
                                                Inactive
                                            </label>
                                    }
                                    <input checked={active} onChange={() => setActive(!active)} className="ml-2" type="checkbox" />
                                </label>
                            </div>
                        </div>

                        <button disabled={processing} onClick={handleSubmit} className="btn btn-sm btn-primary mt-4">
                            {processing || loading ? 'Loading ...' : 'Update'}
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default EditTestimonial;
